export default "../fonts/logo-abitare-co.svg";